import React from 'react';

const C = {
  ink: '#333333',
  sub: '#666666',
  line: '#ECECEE',
  primary: '#FF6467',
  surface: '#FFFFFF',
  danger: '#E05C35',
};

const SectionNumOfPeople = ({ event, setEvent, capacityError, setPlaceError }) => {
  const numOfPeopleList = React.useMemo(() => {
    let num_of_people = [];
    let extra_numbers = [200,300,400,500,600,700,800,900,1000,1200,1400,1600,1800,2000,2500,3000,3500,4000,4500,5000,6000,7000,8000,9000,10000,11000,12000,13000,14000,15000,16000,17000,18000,19000,20000,21000,22000,23000,24000,25000,26000,27000,28000,29000,30000,31000,32000,33000,34000,35000,36000,37000,38000,39000,40000,45000,50000,55000,60000,65000,70000,75000,80000,85000,90000,95000,100000,200000,300000,400000,500000,600000,700000,800000,900000,1000000];
    for (let i = 2; i <= 100; i++) {
      num_of_people.push(i);
    }
    for (const extra_number of extra_numbers) {
      num_of_people.push(extra_number);
    }
    return num_of_people.map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  }, []);

  const onPlaceError = React.useCallback(() => {
    if (!event.is_online && !event.place) {
      setPlaceError('集合場所を入力してください。');
    } else {
      setPlaceError('');
    }
  }, [event]);

  const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '13px 0',
    margin: 0,
  };
  const labelStyle = { fontSize: 14, color: C.ink, margin: 0, flex: 'none' };
  const selectStyle = {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: 15,
    fontWeight: 700,
    color: C.ink,
    textAlign: 'right',
    textAlignLast: 'right',
    padding: 0,
  };

  return (
    <section id="num_of_people">
      <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
        <div
          style={{
            background: C.surface,
            border: `1px solid ${capacityError ? C.danger : C.line}`,
            borderRadius: 16,
            padding: '14px 16px',
            boxShadow: '0 1px 2px rgba(30,30,40,.03), 0 10px 26px -16px rgba(30,30,40,.14)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 800, color: C.sub, letterSpacing: '.02em' }}>募集人数</span>
          </div>
          {!!capacityError && (
            <p style={{ color: C.danger, fontSize: 12, margin: '6px 0 0' }}>{capacityError}</p>
          )}
          <div style={{ ...rowStyle, borderBottom: `1px solid ${C.line}` }}>
            <p style={labelStyle}>最小人数</p>
            <select
              id="min_num_of_people"
              onChange={(e) => {
                const min_num_of_people = Number(e.target.value);
                setEvent((prev) => ({ ...prev, min_num_of_people }));
              }}
              onClick={() => onPlaceError()}
              defaultValue={event.min_num_of_people}
              style={selectStyle}
            >
              {numOfPeopleList}
            </select>
          </div>
          <div style={rowStyle}>
            <p style={labelStyle}>最大人数</p>
            <select
              id="capacity"
              onChange={(e) => {
                const capacity = e.target.value === '' ? null : Number(e.target.value);
                setEvent((prev) => ({ ...prev, capacity }));
              }}
              onClick={() => onPlaceError()}
              defaultValue={event.capacity || ''}
              style={selectStyle}
            >
              <option value={''}>制限なし</option>
              {numOfPeopleList}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionNumOfPeople;
